import React from 'react'
import { connect } from 'react-redux'
import { createIdea } from 'services/create_idea'
import AlertModalView from 'support/popup_dialogs/views/components/alert_modal_view/AlertModalView'
import { hideDialog } from 'support/popup_dialogs/modal_alert_controller/ModalActions'
import { showPopupDialog } from 'support/popup_dialogs'
import i18n from 'support/i18n'
import SuccessModel from './SuccessModel'
import ErrorModel from './ErrorModel'
import Navigation from 'support/navigation'
// import {  } from 'services/domain'
import { configService,postIsHackathonDomainService } from 'services/domain'

const mapStateToProps = () => ({

  title: i18n.t('CONFIRMATION_MESSAGE'),
  description: 'Do you really want to change your Hackathon mode settings?',
  mainButtonText: i18n.t('ACCEPT'),
  cancelable: true,
  cancelButtonText: i18n.t('CANCEL'),
})

const mapDispatchToProps = (dispatch, ownProps) => {
  const messageSwitch = ownProps?.isflag
  ? 'Hackathon mode has been successfully enabled. This will activate special features for your team.'
  : 'Hackathon mode has been successfully disabled. This action will deactivate related features.';


  return {
    mainButtonAction: () => {
      const onSuccess = response => {
        showPopupDialog(<SuccessModel description={messageSwitch} />, dispatch)
        dispatch(Navigation.navigateToExplore())
      }
      const onFailure = ({ data }) => {
        const messageTag =
          data && data.error && data.error.error
            ? `BACKEND_ERRORS.${data.error.error}`
            : 'BACKEND_ERRORS.UNEXPECTED'
        showPopupDialog(<ErrorModel description={i18n.t(messageTag)} />, dispatch)
      }
      dispatch(postIsHackathonDomainService(ownProps.isflag, onSuccess, onFailure))
      dispatch(configService())
      dispatch(hideDialog())
      window.location.reload();
    },
    cancelButtonAction: () => dispatch(hideDialog()),

  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AlertModalView)
